<template>
  <button v-if="!link" :class="mode">
    <slot></slot>
  </button>
  <router-link v-else :to="to" :class="mode">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: false,
      default: null
    },
    link: {
      type: Boolean,
      required: false,
      default: false
    },
    to: {
      type: String,
      required: false,
      default: '/'
    }
  },
  computed: {
    buttonBackground() {
      return this.$store.getters.foregroundColor;
    },
    buttonHighlight() {
      return this.$store.getters.backgroundColor;
    },
  },
}
</script>

<style scoped>
button,
a {
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  font: inherit;
  font-size: 0.85rem;
  background-color: v-bind('buttonBackground');
  border: 1px solid v-bind('buttonBackground');
  color: white;
  cursor: pointer;
  border-radius: 30px;
  margin-right: 0.5rem;
  display: inline-block;
}

a:hover,
a:active,
button:hover,
button:active {
  background-color: v-bind('buttonHighlight');
  border-color: v-bind('buttonHighlight');
}

button:disabled {
  color: grey;
}

.flat {
  background-color: transparent;
  color: v-bind('buttonBackground');
  border: none;
}

.outline {
  background-color: transparent;
  border-color: v-bind('buttonHighlight');
  color: v-bind('buttonHighlight');
}

.flat:hover,
.flat:active,
.outline:hover,
.outline:active {
  background-color: v-bind('buttonHighlight');
}

@media(min-width: 64rem) {
  button,
  a {
    font-size: 1rem;
  }
}
</style>